// Provider adapter contracts. Each domain has a small interface; every adapter
// normalizes its upstream to the shared shape so the UI never knows which
// source a number came from.

import type {
  RaceConfig,
  VoteProviderConfig,
  MarketProviderConfig,
  FinanceProviderConfig,
} from './config.ts';
import type { NormalizedResult } from './results.ts';
import type { MarketResult } from './markets.ts';
import type { FinanceResult } from './finance.ts';
import type { ErrorKind } from './ui.ts';

/** Typed error thrown by adapters; the hook layer maps `.kind` → ProviderState. */
export class ProviderError extends Error {
  kind: ErrorKind;
  constructor(kind: ErrorKind, message: string) {
    super(message);
    this.name = 'ProviderError';
    this.kind = kind;
  }
}

export interface VoteProvider {
  id: string;
  kind: 'votes';
  getResults(
    race: RaceConfig,
    cfg: VoteProviderConfig,
    signal?: AbortSignal,
  ): Promise<NormalizedResult>;
}

export interface MarketProvider {
  id: 'polymarket' | 'kalshi';
  kind: 'markets';
  getMarket(
    race: RaceConfig,
    cfg: MarketProviderConfig,
    signal?: AbortSignal,
  ): Promise<MarketResult>;
}

export interface FinanceProvider {
  id: 'fec';
  kind: 'finance';
  getFinance(
    race: RaceConfig,
    cfg: FinanceProviderConfig,
    signal?: AbortSignal,
  ): Promise<FinanceResult>;
}
